import clientConfigApi from "../../../../config/config"


const updateFCMTokenForRegisterDevice = async (token) => {

    if(!token || token == ""){
        console.log("No FCM Token Found")
        return;
    }

    const deviceType = window.device ? window.device.platform : "Other";

    const body = {
        "header" : {
        "sessionToken" :localStorage.getItem("GuestJourneySessionToken"),
        "deviceType" : deviceType
        },
        "payload": {
            "deviceTokenIdentifier" : token
        }
    }

    try {
        let data = await clientConfigApi.put(`/guestDevice/update`, body)

        console.log("success updating FCM Token")
    } catch (error) {
        console.log("error updating FCM Token")
    }
}


export const getFCMToken = () => {

    // console.log("push notification called");

    window.FirebasePlugin.getToken(function(token) {   
        // console.log("FCM token",token);
        updateFCMTokenForRegisterDevice(token)
        localStorage.setItem("FCM_token",token)
    }, errCallback);
   
}


const errCallback = (error) => {
    console.error("FCM token error",error);
}